<template>
  <div class="content">
    <iframe :src="url" height="100%" width="100%" class="iframe_style" />
  </div>
</template>

<script>
import storage from "@/utils/storage";

export default {
  props: ["device"],
  data() {
    return {
      url: "",
      ts: new Date().getTime(),
    };
  },
  mounted() {
    const openId = storage.getCache("openId");
    this.$http.wechat.getAccessToken({ openId: openId }).then((res) => {
      if (res) {
        this.url =
          this.device.uicomponentUrl +
          "/?token=bearer" +
          res.accessToken +
          "&device_id=" +
          this.device.id +
          "&ts=" +
          this.ts;
      }
    });
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.content {
  height: calc(100vh - 94px);
  width: 100%;
}
.iframe_style {
  border: medium none;
}
</style>
